<script setup lang="ts">
  import { UserBroadcastWarningIconMap } from '@/types/systemSettings.types';
  import CollapsableText from '@/components/common/CollapsableText/CollapsableText.vue';
  import useUserBroadcastMessages from '@/composables/userBroadcastMessages/useUserBroadcastMessages';
  import useLocale from '@/composables/useLocale';
  import type { IconName } from '@/types';
  import SvgIcon from '@/components/common/SvgIcon/SvgIcon.vue';

  defineOptions({ name: 'UserBroadcastWarning' });

  const iconsMap: Record<UserBroadcastWarningIconMap, IconName> = {
    [UserBroadcastWarningIconMap.default]: 'exclamation-round-border',
  };

  const { warnings } = useUserBroadcastMessages();
  const locale = useLocale();

</script>

<template>
  <div
    v-if="warnings.length"
    class="flex flex-col gap-4 wrap-anywhere print:hidden"
  >
    <template
      v-for="warning in warnings"
      :key="warning.id"
    >
      <div class="w-full rounded border-2 border-yellow bg-yellow-extralight text-left md:container">
        <div class="grid grid-cols-[1.5rem_1fr] gap-3 px-5 py-4">
          <SvgIcon
            v-if="warning.icon"
            :icon="iconsMap[warning.icon]"
            size="default"
            class="text-yellow"
          />

          <div class="flex flex-col gap-3">
            <p
              class="font-bold "
            >
              {{ warning.title[locale] }}
            </p>
            <CollapsableText
              :text="warning.content[locale]"
              link-class="text-blue-accessible"
              :markdown-binding="{
                classes: {a: 'hover:no-underline'}
              }"
            />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
